import React from "react";
import { PopupCampaignStatus } from "../../api/generated/models/PopupCampaignStatus";
import { statusBadgeClass, statusLabel } from "../../helpers/popupCampaignForm";

export const StatusBadge: React.FC<{ status?: PopupCampaignStatus; className?: string }> = ({
  status,
  className = "",
}) => (
  <span
    className={`text-xs px-2 py-0.5 rounded-full font-medium ${statusBadgeClass(status)} ${className}`}
  >
    {statusLabel(status)}
  </span>
);
